import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { type CampaignFilters, promotionKeys } from "./query-keys";

export function useCampaigns(filters?: CampaignFilters) {
  return useQuery({
    queryKey: promotionKeys.campaigns(filters),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/campaigns", {
        params: { query: filters ?? {} },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
